import React,{useState,useEffect} from 'react'
import { Tab, Nav } from "react-bootstrap";
import videoProfile from "../../Assets/images/video-profiles1.png"
import digitalPortfolio from "../../Assets/images/pre-screened-verified.png"
import preScreenedVerified from "../../Assets/images/pre-screened-verified1.png"
import vp1 from "../../Assets/images/vp1.png"
import vp2 from "../../Assets/images/vp2.png"
import vp3 from "../../Assets/images/vp3.png"
import vp4 from "../../Assets/images/vp4.png"
import dp1 from "../../Assets/images/dp1.png"
import dp3 from "../../Assets/images/dp3.png"
import dp4 from "../../Assets/images/dp4.png"
import cb1 from "../../Assets/images/cb1.png"
import cb2 from "../../Assets/images/cb2.png"
import cb3 from "../../Assets/images/cb3.png"
import cb4 from "../../Assets/images/cb4.png"
const Tabs = ({className}) => {
     const [activeKey, setActiveKey] = useState("tab1");
  const tabs = [
    { key: "tab1", title: "Tab 1", content: "This is Tab 1 content" },
    { key: "tab2", title: "Tab 2", content: "This is Tab 2 content" },
    { key: "tab3", title: "Tab 3", content: "This is Tab 3 content" }
  ];
  useEffect(() => {
    const id = setInterval(() => {
      const idx = tabs.findIndex(t => t.key === activeKey);
      const nextIdx = (idx + 1) % tabs.length;
      setActiveKey(tabs[nextIdx].key);
    }, 3000);

    return () => clearInterval(id);
  }, [activeKey, tabs]);

  
  const handleSelect = (key) => {
    setActiveKey(key);
  };
  return (
    <>
    <section className={`tab-sec ${className}`}>
          <div className='container'>
            <div className="mp-banner-content text-center mw-100">
                <h2 className='heading-title'>
                    Showcase Your Talent &  <br /> Skills, Get Hired Faster
                </h2>
            </div>
            <div className='design-tabs'>
              <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
                <Nav variant="tabs" className='border-0'>
                    <Nav.Item key='tab1'>
                      <Nav.Link eventKey='tab1'>Video Profiles</Nav.Link>
                    </Nav.Item>
                    <Nav.Item key='tab2'>
                      <Nav.Link eventKey='tab2'>Digital Portfolio</Nav.Link>
                    </Nav.Item>
                    <Nav.Item key='tab3'>
                      <Nav.Link eventKey='tab3'>Career Boost</Nav.Link>
                    </Nav.Item>
                </Nav>

                <Tab.Content className="pt-5">
                    <Tab.Pane key='tab1' eventKey='tab1'>
                        <div className='row'>
                            <div className='col-lg-6 d-flex align-items-center'>
                                <img src={videoProfile} alt='' className='mw-100' />
                            </div>
                            <div className='col-lg-6'>
                                <div className='tab-icon-sec'>
                                    <p>Stand out beyond your resume.</p>
                                    <div className='row'>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={vp1} alt='' />
                                                <h2>
                                                  Showcase your personality and confidence
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={vp2} alt='' />
                                                <h2>
                                                  Make a strong first impression with recruiters
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={vp3} alt='' />
                                                <h2>
                                                  Highlight your communication skills
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={vp4} alt='' />
                                                <h2>
                                                  Tell your story in your own words
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab.Pane>
                    <Tab.Pane key='tab2' eventKey='tab2'>
                    <div className='row'>
                            <div className='col-lg-6 d-flex align-items-center'>
                                <img src={digitalPortfolio} alt='' className='mw-100' />
                            </div>
                            <div className='col-lg-6'>
                                <div className='tab-icon-sec'>
                                    <p>Get a quick sense of candidates before the interview.</p>
                                    <div className='row'>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={dp1} alt='' />
                                                <h2>
                                                Evaluate communication & presence instantly
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={vp2} alt='' />
                                                <h2>
                                                Spot personality fit early in the process
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={dp3} alt='' />
                                                <h2>
                                                Save time screening resumes
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={dp4} alt='' />
                                                <h2>
                                                Make informed shortlist decisions faster
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab.Pane>
                    <Tab.Pane key='tab3' eventKey='tab3'>
                        <div className='row'>
                            <div className='col-lg-6 d-flex align-items-center'>
                                <img src={preScreenedVerified} alt='' className='mw-100' />
                            </div>
                            <div className='col-lg-6'>
                                <div className='tab-icon-sec'>
                                    <p>Only meet candidates who’ve cleared the basics.</p>
                                    <div className='row'>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={cb1} alt='' />
                                                <h2>
                                                Identity & background verified
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={cb2} alt='' />
                                                <h2>
                                                Skills assessed and validated
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={cb3} alt='' />
                                                <h2>
                                                Work eligibility confirmed
                                                </h2>
                                            </div>
                                        </div>
                                        <div className='col-6 col-lg-6'>
                                            <div className='icon-box'>
                                                <img src={cb4} alt='' />
                                                <h2>
                                                Pre-screening aligned to role requirements
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            <div className='d-none d-lg-flex align-items-center justify-content-center pt-3 pt-md-5'><a href='#' className='default-btn blue-bg border-0 px-5 py-3 fs-3'>Create Your Digital Portfolio Now</a></div>
          </div>
      </section>
    </>
  )
}

export default Tabs